export default __webpack_public_path__ + "static/media/notification_settings_bell_white.7532e33a.svg";